import * as types from '../API/ActionTypes';
import InitialState from './initialState';

export function userDetailsErrorReducer(state = InitialState.userDetailsErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.USER_DETAILS_ERROR:
			return action.userDetailsErrorFlag;
		default:
			return state;
	}
}

export function userDetailsLoadingReducer(state = InitialState.userDetailsLoading, action) 
{
	switch (action.type) 
	{
		case types.USER_DETAILS_LOADING:
			return action.userDetailsLoading;
		default:
			return state;
	}
}

export function userDetailsReducer(state = InitialState.userDetails, action) 
{
	switch (action.type) 
	{
		case types.USER_DETAILS:
			return action.userDetails;
		default:
			return state;
	}
}

export function userListErrorReducer(state = InitialState.userOutputErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.USER_LIST_ERROR:
			return action.userOutputErrorFlag;
		default:
			return state;
	}
}

export function userListLoadingReducer(state = InitialState.userOutputDataLoading, action) 
{
	switch (action.type) 
	{
		case types.USER_LIST_LOADING:
			return action.userOutputDataLoading;
		default:
			return state;
	}
}

export function userListReducer(state = InitialState.userOutputData, action) 
{
	switch (action.type) 
	{
		case types.USER_LIST:
			return action.userOutputData;
		default:
			return state;
	}
}
